import styled from 'styled-components'
import theme from '../../../styles/theme'
export const MainWrapper = styled.div``
export const ComputerInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    width: 20%;
  }

  input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  label {
    border-width: 0;
  }
  .inputfile + label {
    font-size: 1.25em;
    font-weight: 700;
    color: ${theme.colors.darkGray};
    display: inline-block;
  }

  .inputfile + label {
    cursor: pointer;
  }
`
export const PhoneInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  label {
    font-size: 22px;
  }
`
export const FilesContainer = styled.div``
export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    margin: 0 3% 0 3%;
  }
`
